<mat-toolbar class="content-header">
    <mat-toolbar-row>
        <h1 class="page-title">
            <mat-icon class="title-icon">dashboard</mat-icon>
            {{'projects.project_dashboard' | translate}}
        </h1>

        <span class="toolbar-spacer"></span>

        <div class="tab-menu">
            <!-- Section Navigation Date -->
            <div class="toolbar-section date-navigation">
                <div class="date-picker">
                    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_left"
                        (click)="navigateDate(-1)">
                    </lib-button>

                    <app-date-picker *ngIf="!showEndDate" [startDate]="startDate" [min]="currentProject?.createdDate"
                        (dateChanged)="onPickerChanged($event)" [hideTime]="true">
                    </app-date-picker>

                    <app-range-picker *ngIf="showEndDate" [startDate]="startDate" [endDate]="endDate"
                        (change)="onRangePickerChanged($event)">
                    </app-range-picker>

                    <lib-button *ngIf="!showEndDate" size="small" color="none" icon="date_range"
                        (click)="onShowEndChange()" tooltip="{{ 'dashboard.enable_date_range' | translate }}">
                    </lib-button>

                    <lib-button *ngIf="showEndDate" size="small" color="none" icon="close" (click)="onShowEndChange()">
                    </lib-button>

                    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_right"
                        (click)="navigateDate(1)" [disabled]="!canNavigateNext">
                    </lib-button>
                </div>
            </div>

            <lib-button customClass="refresh-btn" [icon]="'refresh'" [color]="'secondary'" (click)="refreshAllWidgets()"
                tooltip="{{ 'workflows.refresh' | translate }}">
            </lib-button>

            <lib-button *ngIf="this.user.role.name !== 'user' && this.user.role.name !== 'guest'" [icon]="'add_chart'"
                (click)="addWidgetEditor()" tooltip="{{ 'form.add' | translate }}">
            </lib-button>

            <lib-button [matMenuTriggerFor]="menu" color="muted" icon="more_horiz">
            </lib-button>

            <mat-menu #menu="matMenu" class="modern-menu">
                <button mat-menu-item (click)="shareExport()" class="share-btn">
                    <mat-icon color="primary" fontIcon="cloud_download"></mat-icon>
                    <span>{{'dashboard.share.export' | translate}}</span>
                </button>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<main class="content">
    <mat-drawer-container class="drawer-container" autosize>
        <!-- Écran de chargement -->
        <ng-container *ngIf="loadingDashboard">
            <div class="loading-overlay">
                <app-spinner [text]="'status.dashboard_loading' | translate"></app-spinner>
            </div>
        </ng-container>

        <!-- Cas 1: Dashboard avec widgets -->
        <ng-container
            *ngIf="personalDashboard && personalDashboard.charts && personalDashboard.charts.length > 0 && !loadingDashboard && projectsLoaded && selectedProjects.length > 0">
            <app-dashboard-panel [dashboard]="personalDashboard" [filters]="filters" [projects]="selectedProjects"
                [project]="projects" [refreshSignal]="refreshSignal" [exportSignal]="exportSignal">
            </app-dashboard-panel>
        </ng-container>

        <!-- Cas 2: Dashboard sans widgets -->
        <ng-container
            *ngIf="personalDashboard && (!personalDashboard.charts || personalDashboard.charts.length === 0) && !loadingDashboard">
            <lib-no-data [icon]="'dashboard'" [message]="'dashboard.empty.no_title'"
                [description]="'dashboard.empty.no_description'">
                <ng-container *ngIf="this.user.role.name !== 'user' && this.user.role.name !== 'guest'">
                    <lib-button [icon]="'add_chart'" (click)="addWidgetEditor()" color="primary"
                        text="{{ 'dashboard.manager.add' | translate }}">
                    </lib-button>
                </ng-container>
            </lib-no-data>
        </ng-container>
    </mat-drawer-container>
</main>